import VueRouter from "vue-router";
// 关闭重复跳页面报错
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}
// 页面
import routerLab from '@/view/routerLab';

import login from '@/view/auth/login';
import reg from '@/view/auth/reg';
import cpwd from '@/view/auth/cpwd';


import home from '@/view/home/home';
import dynamic from '@/view/home/dynamic';

import newsList from '@/view/home/newsList';
import industryList from '@/view/home/industryList';
import safetyList from '@/view/home/safetyList';
import skillList from '@/view/home/skillList';
import exhibition from '@/view/home/exhibition';
import peixunTxt from '@/view/home/peixunTxt';
import dangTxt from '@/view/home/dangTxt';

import dynamicMsg from '@/view/home/dynamicMsg';
import study from '@/view/home/study';
import studyMsg from '@/view/home/studyMsg';
import cardSeach from '@/view/home/cardSeach';
import download from '@/view/home/download';

import tongzhiList from '@/view/user/tongzhiList';
import tongzhiMsg from '@/view/user/tongzhiMsg';


import userHome from '@/view/user/userHome';
import userNews from '@/view/user/userNews';
import userCourse from '@/view/user/userCourse';
import userCourseMsg from '@/view/user/userCourseMsg';
import userCourseFrom from '@/view/user/userCourseFrom';
import userCoursePay from '@/view/user/userCoursePay';
import userCoursePaySuss from '@/view/user/userCoursePaySuss';
import userOrder from '@/view/user/userOrder';
import userOrderQY from '@/view/user/userOrderQY';
import userOrderQYMsg from '@/view/user/userOrderQYMsg';
import classList from '@/view/user/classList';
import classMsg from '@/view/user/classMsg';
import classStudy from '@/view/user/classStudy';
import classProblem from '@/view/user/classProblem';
import classShuati from '@/view/user/classShuati';
import classTest from '@/view/user/classTest';
import classVideo from '@/view/user/classVideo';
import examList from '@/view/user/examList';
import userMsg from '@/view/user/userMsg';
import userMsgKp from '@/view/user/userMsgKp';
import fapiaoList from '@/view/user/fapiaoList';
import fapiaoMsg from '@/view/user/fapiaoMsg';


import qyClass from '@/view/user/qyClass';
import qyClassMan from '@/view/user/qyClassMan';
import qyClassMan1 from '@/view/user/qyClassMan1';
import qyClassMan2 from '@/view/user/qyClassMan2';
import qyClassManAdd from '@/view/user/qyClassManAdd';
import qyClassManFrom from '@/view/user/qyClassManFrom';
import qyClassMsg from '@/view/user/qyClassMsg';
import qyTrain from '@/view/user/qyTrain';
import qyTrainMan from '@/view/user/qyTrainMan';
import qyStaff from '@/view/user/qyStaff';
import qyInfo from '@/view/user/qyInfo';
import qyInfoRemake from '@/view/user/qyInfoRemake';

// 路由
export default new VueRouter({
    routes:[
        {
            path:'/',
            component:routerLab,
			redirect: '/home',
			children:[
				
				
				
				
				{
					path: 'home',
					component: home,
				},
				
				{
					path: 'login',
					component: login,
				},
				{
					path: 'reg',
					component: reg,
				},
				{
					path: 'cpwd',
					component: cpwd,
				},
				
				
				{
					path: 'dynamic',
					component: dynamic,
				},
				{
					path: 'newsList',
					component: newsList,
				},
				{
					path: 'industryList',
					component: industryList,
				},
				{
					path: 'safetyList',
					component: safetyList,
				},
				{
					path: 'skillList',
					component: skillList,
				},
				{
					path: 'exhibition',
					component: exhibition,
				},
				{
					path: 'peixunTxt',
					component: peixunTxt,
				},
				{
					path: 'dangTxt',
					component: dangTxt,
				},
				{
					path: 'dynamicMsg',
					component: dynamicMsg,
				},
				{
					path: 'study',
					component: study,
				},
				{
					path: 'studyMsg',
					component: studyMsg,
				},
				{
					path: 'cardSeach',
					component: cardSeach,
				},
				{
					path: 'download',
					component: download,
				},
				
				
				{
					path: 'userHome',
					component: userHome,
				},
				{
					path: 'tongzhiMsg',
					component: tongzhiMsg,
				},
				{
					path: 'tongzhiList',
					component: tongzhiList,
				},
				{
					path: 'userNews',
					component: userNews,
				},
				{
					path: 'userCourse',
					component: userCourse,
				},
				{
					path: 'userCourseMsg',
					component: userCourseMsg,
				},
				{
					path: 'userCourseFrom',
					component: userCourseFrom,
				},
				{
					path: 'userCoursePay',
					component: userCoursePay,
				},
				{
					path: 'userCoursePaySuss',
					component: userCoursePaySuss,
				},
				{
					path: 'userOrder',
					component: userOrder,
				},
				{
					path: 'userOrderQY',
					component: userOrderQY,
				},
				{
					path: 'userOrderQYMsg',
					component: userOrderQYMsg,
				},
				{
					path: 'classList',
					component: classList,
				},
				{
					path: 'classMsg',
					component: classMsg,
				},
				{
					path: 'classStudy',
					component: classStudy,
				},
				{
					path: 'classProblem',
					component: classProblem,
				},
				{
					path: 'classShuati',
					component: classShuati,
				},
				{
					path: 'classTest',
					component: classTest,
				},
				{
					path: 'classVideo',
					component: classVideo,
				},
				{
					path: 'examList',
					component: examList,
				},
				{
					path: 'userMsg',
					component: userMsg,
				},
				{
					path: 'userMsgKp',
					component: userMsgKp,
				},
				{
					path: 'fapiaoList',
					component: fapiaoList,
				},
				{
					path: 'fapiaoMsg',
					component: fapiaoMsg,
				},
				
				
				{
					path: 'qyClass',
					component: qyClass,
				},
				{
					path: 'qyClassMan',
					component: qyClassMan,
				},
				{
					path: 'qyClassMan1',
					component: qyClassMan1,
				},
				{
					path: 'qyClassMan2',
					component: qyClassMan2,
				},
				{
					path: 'qyClassManAdd',
					component: qyClassManAdd,
				},
				{
					path: 'qyClassManFrom',
					component: qyClassManFrom,
				},
				{
					path: 'qyClassMsg',
					component: qyClassMsg,
				},
				{
					path: 'qyTrain',
					component: qyTrain,
				},
				{
					path: 'qyTrainMan',
					component: qyTrainMan,
				},
				{
					path: 'qyStaff',
					component: qyStaff,
				},
				{
					path: 'qyInfo',
					component: qyInfo,
				},
				{
					path: 'qyInfoRemake',
					component: qyInfoRemake,
				}
				
			]
        }
    ]
})
